import { generateId, getReducerErrorMessage } from 'src/utils/helpers'

const initialState = {
  isGetGroupsInProgress: false,
  getGroupsResponse: {},
  groups: [],
  groupsItemsCount: '0',
  groupsItemsValue: '0',
  isGetGroupInProgress: false,
  getGroupResponse: {},
  group: {},
  items: [],
  isSaveGroupInProgress: false,
  saveGroupResponse: {},
  deleteGroupResponse: {},
  isGetItemInProgress: false,
  getItemResponse: {},
  isSaveItemInProgress: false,
  saveItemResponse: {},
  deleteItemResponse: {},
  deleteFileResponse: {},
  newItemFiles: [],
  isExportInProgress: false,
  exportResponse: {}
}

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case 'GET_INVENTORY_GROUPS': {
      return {
        ...state,
        isGetGroupsInProgress: true,
        getGroupsResponse: {},
      }
    }
    case 'GET_INVENTORY_GROUPS_COMMIT': {
      let newState = {
        ...state,
        isGetGroupsInProgress: false,
        getGroupsResponse: {
          success: true,
        },
      }

      if(!(action.payload && action.payload.data)) {
        return newState;
      }

      if(action.payload.data.groups) {
        newState.groups = action.payload.data.groups
      }
      if(action.payload.data.groupsItemsCount) {
        newState.groupsItemsCount = action.payload.data.groupsItemsCount
      }
      if(action.payload.data.groupsItemsValue) {
        newState.groupsItemsValue = action.payload.data.groupsItemsValue
      }

      return newState
    }
    case 'GET_INVENTORY_GROUPS_ROLLBACK': {
      return {
        ...state,
        isGetGroupsInProgress: false,
        getGroupsResponse: {
          success: false,
          message: getReducerErrorMessage(action),
        },
      }
    }
    
    case 'GET_INVENTORY_GROUP': {
      return {
        ...state,
        isGetGroupInProgress: true,
        getGroupResponse: {},
        group: {},
        items: [],
      }
    }
    case 'GET_INVENTORY_GROUP_COMMIT': {
      return {
        ...state,
        isGetGroupInProgress: false,
        getGroupResponse: {
          success: true,
        },
        group: action.payload.data.group,
        items: action.payload.data.items,
      }
    }
    case 'GET_INVENTORY_GROUP_ROLLBACK': {
      return {
        ...state,
        isGetGroupInProgress: false,
        getGroupResponse: {
          success: false,
          message: getReducerErrorMessage(action),
        },
      }
    }

    case 'SAVE_INVENTORY_GROUP' : {
      return {
        ...state,
        isSaveGroupInProgress: true,
        saveGroupResponse: {},
      }
    }
    case 'SAVE_INVENTORY_GROUP_COMMIT' : {
      return {
        ...state,
        isSaveGroupInProgress: false,
        saveGroupResponse: {
          success: true,
        },
      }
    }
    case 'SAVE_INVENTORY_GROUP_ROLLBACK' : {
      return {
        ...state,
        isSaveGroupInProgress: false,
        saveGroupResponse: {
          success: false,
          message: getReducerErrorMessage(action),
        },
      }
    }

    case 'DELETE_INVENTORY_GROUP' : {
      return {
        ...state,
        deleteGroupResponse: {},
      }
    }
    case 'DELETE_INVENTORY_GROUP_COMMIT' : {
      return {
        ...state,
        deleteGroupResponse: {
          success: true,
        },
      }
    }
    case 'DELETE_INVENTORY_GROUP_ROLLBACK' : {
      return {
        ...state,
        deleteGroupResponse: {
          success: false,
          message: getReducerErrorMessage(action),
        },
      }
    }

    case 'GET_INVENTORY_ITEM': {
      return {
        ...state,
        isGetItemInProgress: true,
        getItemResponse: {},
      }
    }
    case 'GET_INVENTORY_ITEM_COMMIT': {
      return {
        ...state,
        isGetItemInProgress: false,
        getItemResponse: {
          success: true,
          item: action.payload.data,
        },
      }
    }
    case 'GET_INVENTORY_ITEM_ROLLBACK': {
      return {
        ...state,
        isGetItemInProgress: false,
        getItemResponse: {
          success: false,
          message: getReducerErrorMessage(action),
        },
      }
    }

    case 'SAVE_INVENTORY_ITEM' : {
      return {
        ...state,
        isSaveItemInProgress: true,
        saveItemResponse: {},
      }
    }
    case 'SAVE_INVENTORY_ITEM_COMMIT' : {
      return {
        ...state,
        isSaveItemInProgress: false,
        saveItemResponse: {
          success: true,
        },
      }
    }
    case 'SAVE_INVENTORY_ITEM_ROLLBACK' : {
      return {
        ...state,
        isSaveItemInProgress: false,
        saveItemResponse: {
          success: false,
          message: getReducerErrorMessage(action),
        },
      }
    }

    case 'DELETE_INVENTORY_ITEM' : {
      return {
        ...state,
        deleteItemResponse: {},
      }
    }
    case 'DELETE_INVENTORY_ITEM_COMMIT' : {
      return {
        ...state,
        deleteItemResponse: {
          success: true,
        },
      }
    }
    case 'DELETE_INVENTORY_ITEM_ROLLBACK' : {
      return {
        ...state,
        deleteItemResponse: {
          success: false,
          message: getReducerErrorMessage(action),
        },
      }
    }

    case 'DELETE_INVENTORY_FILE' : {
      return {
        ...state,
        deleteFileResponse: {},
      }
    }
    case 'DELETE_INVENTORY_FILE_COMMIT' : {
      return {
        ...state,
        deleteFileResponse: {
          success: true,
        },
      }
    }
    case 'DELETE_INVENTORY_FILE_ROLLBACK' : {
      return {
        ...state,
        deleteFileResponse: {
          success: false,
          message: getReducerErrorMessage(action),
        },
      }
    }

    case 'NEW_ITEM_FILES_ADD': {
      const file = action.payload.hasOwnProperty('file') && action.payload.file ? action.payload.file : null
      if(!file) {
        return state
      }

      return {
        ...state,
        newItemFiles: [...state.newItemFiles, {
          // Add random it (to allow removing from state)
          stateId: generateId(),
          ...file,
        }]
      }
    }

    case 'NEW_ITEM_FILES_REMOVE': {
      const file = action.payload.file || null
      if(!(file && file.stateId && state.newItemFiles && state.newItemFiles.length > 0)) {
        return state
      }

      return {
        ...state,
        newItemFiles: state.newItemFiles.filter(f => f.stateId !== file.stateId)
      }
    }

    case 'NEW_ITEM_FILES_CLEAR': {
      return {
        ...state,
        newItemFiles: []
      }
    }

    case 'INVENTORY_EXPORT': {
      return {
        ...state,
        isExportInProgress: true,
        exportResponse: {}
      }
    }
    case 'INVENTORY_EXPORT_COMMIT': {
      return {
        ...state,
        isExportInProgress: false,
        exportResponse: {
          success: true,
        },
      }
    }
    case 'INVENTORY_EXPORT_ROLLBACK': {
      return {
        ...state,
        isExportInProgress: false,
        exportResponse: {
          success: false,
          message: getReducerErrorMessage(action),
        },
      }
    }

    default: {
      return state
    }
  }
}
